export const KEY_CODES = { arrowDown: 40, arrowUp: 38, enter: 13, esc: 27, spacebar: 32 };

export const MOVE_OPTIONS = { next: 'next', prev: 'prev' };

export const MAX_STRING_LENGTH = { label: 40, option: 45 };

export const DECORATE_LARGE_STRING = '...';

export const MOUSE_EVENTS = {
  createEventName: 'MouseEvents',
  clickConfig: ['mousedown', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null],
  onMouseDown: 'onmousedown'
};
